import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { SuperficieSub } from 'src/app/models/superficieSubterraneo.model';

@Component({
  selector: 'app-superficie-sub',
  templateUrl: './superficie-sub.component.html',
  styleUrls: ['./superficie-sub.component.css']
})
export class SuperficieSubComponent {


  @ViewChild('openModal') openModal: TemplateRef<any>;
  @ViewChild('openModalNODATA') openModalNODATA: TemplateRef<any>;



  public rows = [];
  public actualRow;
  public antecedente: SuperficieSub;
  public formSuper;
  public temp_ant;
  public idForm;
  public form33 = false;
  public form35 = false;
  public form131;

  public form231;
  public form232;
  public form233;
  public form234;
  public form235;

  public form251;
  public form252;
  public form253;
  public form254;
  public form255;
  constructor(
    private dialog: MatDialog,

  ) {
    this.idForm = localStorage.getItem("form");

    if (this.idForm == "1-3.1") {
      this.form131 = true
    }

    if (this.idForm == "2-3.3") {
      this.form33 = true
    }
    if (this.idForm == "2-3.5") {
      this.form35 = true
    }

    if (this.idForm == "2-3.1") {
      this.form231 = true;
    }
    if (this.idForm == "2-3.2") {
      this.form232 = true;
    }
    if (this.idForm == "2-3.3") {
      this.form233 = true;
    }
    if (this.idForm == "2-3.4") {
      this.form234 = true;
    }
    if (this.idForm == "2-3.5") {
      this.form235 = true;
    }

    if (this.idForm == "2-5.1") {
      this.form251 = true;
    }
    if (this.idForm == "2-5.2") {
      this.form252 = true;
    }
    if (this.idForm == "2-5.3") {
      this.form253 = true;
    }
    if (this.idForm == "2-5.4") {
      this.form254 = true;
    }
    if (this.idForm == "2-5.5") {
      this.form255 = true;
    }


    if (!JSON.parse(localStorage.getItem("superficieSubterraneo"))) {
      localStorage.setItem("superficieSubterraneo", JSON.stringify(this.rows));
    } else {
      this.rows = JSON.parse(localStorage.getItem("superficieSubterraneo"));

    }


    this.antecedente = { nivelSub: 0, utilSub: 0, comunSub: 0, totalSub: 0, utilSubMod: 0, comunSubMod: 0, totalSubMod: 0 };
    this.temp_ant = { nivelSub: 0, utilSub: 0, comunSub: 0, totalSub: 0, utilSubMod: 0, comunSubMod: 0, totalSubMod: 0 };

    this.formSuper = new FormGroup({
      nivelSub: new FormControl(0),
      utilSub: new FormControl(0),
      comunSub: new FormControl(0),
      totalSub: new FormControl(0),

      utilSubMod: new FormControl(0),
      comunSubMod: new FormControl(0),
      totalSubMod: new FormControl(0)
    })

  }


  add_superficieSubterraneo() {

    this.actualRow = localStorage.getItem("superficieSubterraneo");
    this.rows = JSON.parse(this.actualRow);

    if (!this.form251 && !this.form252 && !this.form253 && !this.form254 && !this.form255 && !this.form131) {
      const { nivelSub, utilSub, comunSub, totalSub } = this.formSuper.value;

      if (
        nivelSub === null || nivelSub === undefined || nivelSub === '' ||
        utilSub === null || utilSub === undefined || utilSub === '' ||
        comunSub === null || comunSub === undefined || comunSub === '' ||
        totalSub === null || totalSub === undefined || totalSub === ''
      ) {
        this.dialog.open(this.openModalNODATA);
      } else {

        this.rows = this.rows.concat({
          nivelSub: this.formSuper.value.nivelSub,
          utilSub: this.formSuper.value.utilSub,
          comunSub: this.formSuper.value.comunSub,
          totalSub: this.formSuper.value.totalSub,
        })


        localStorage.setItem("superficieSubterraneo", JSON.stringify(this.rows));
        this.formSuper.reset();

      }
    }


    if (this.form251 || this.form252 || this.form253 || this.form254 || this.form255 || this.form131) {


      if (!this.formSuper.value.nivelSub || !this.formSuper.value.utilSub || !this.formSuper.value.comunSub || !this.formSuper.value.totalSub || !this.formSuper.value.utilSubMod || !this.formSuper.value.comunSubMod || !this.formSuper.value.totalSubMod) {
        this.dialog.open(this.openModalNODATA);

      } else {

        this.rows = this.rows.concat({
          nivelSub: this.formSuper.value.nivelSub,
          utilSub: this.formSuper.value.utilSub,
          comunSub: this.formSuper.value.comunSub,
          totalSub: this.formSuper.value.totalSub,
          utilSubMod: this.formSuper.value.utilSubMod,
          comunSubMod: this.formSuper.value.comunSubMod,
          totalSubMod: this.formSuper.value.totalSubMod
        })


        localStorage.setItem("superficieSubterraneo", JSON.stringify(this.rows));
      }
    }


  }
  delete_superficieSubterraneo(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("superficieSubterraneo", JSON.stringify(this.rows));
      }
    }
    this.actualRow = localStorage.getItem("superficieSubterraneo");
    this.rows = JSON.parse(this.actualRow);
  }

  onChangeSelect(event) {
    let value = event.target.value;
  }

  get_superficieSubterraneo(id) {
    for (let x = 0; x < this.rows.length; x++) {

      if (id == x) {
        this.temp_ant.nivelSub = this.rows[x].nivelSub;
        this.temp_ant.utilSub = this.rows[x].utilSub;
        this.temp_ant.comunSub = this.rows[x].comunSub;
        this.temp_ant.totalSub = this.rows[x].totalSub;

        this.dialog.open(this.openModal);

      }
    }
  }

  cleanData() {
    this.temp_ant = { nivelSub: 0, utilSub: 0, comunSub: 0, totalSub: 0, utilSubMod: 0, comunSubMod: 0, totalSubMod: 0 };

  }

  savesuperficieSubterraneo() {
    this.dialog.closeAll();
    var id = this.temp_ant.numpermiso;
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("superficieSubterraneo", JSON.stringify(this.rows));

        if (!this.form251 && !this.form252 && !this.form253 && !this.form254 && !this.form255 && !this.form131) {
          this.actualRow = localStorage.getItem("superficieSubterraneo");
          this.rows = JSON.parse(this.actualRow);
          this.rows = this.rows.concat({
            nivelSub: this.temp_ant.nivelSub,
            utilSub: this.temp_ant.utilSub,
            comunSub: this.temp_ant.comunSub,
            totalSub: this.temp_ant.totalSub

          })
        }
        if (this.form251 || this.form252 || this.form253 || this.form254 || this.form255 || this.form131) {
          this.actualRow = localStorage.getItem("superficieSubterraneo");
          this.rows = JSON.parse(this.actualRow);
          this.rows = this.rows.concat({
            nivelSub: this.temp_ant.nivelSub,
            utilSub: this.temp_ant.utilSub,
            comunSub: this.temp_ant.comunSub,
            totalSub: this.temp_ant.totalSub,

            utilSubMod: this.temp_ant.value.utilSubMod,
            comunSubMod: this.temp_ant.value.comunSubMod,
            totalSubMod: this.temp_ant.value.totalSubMod
          })
        }
        localStorage.setItem("superficieSubterraneo", JSON.stringify(this.rows));
        /*   this.temp_ant.reset() */
        this.dialog.closeAll();

      }
    }
  }
}
